<sc-padding leftRightOnly>
  <sc-scroll-pane [formGroup]="formGroup">
    @for (condition of conditions; track $index) {

    <sc-checkbox-field
      [label]="condition.value.getValue(translationService.language) ? condition.value.getValue(translationService.language)!.value : 'undefined'"
      formControlName="condition_{{condition.id}}"></sc-checkbox-field>
    <sc-content-spacer vertical></sc-content-spacer>
    }
  </sc-scroll-pane>
</sc-padding>
